import { render, staticRenderFns } from "./offer.vue?vue&type=template&id=6396392b&scoped=true&"
import script from "./offer.vue?vue&type=script&lang=tsx&"
export * from "./offer.vue?vue&type=script&lang=tsx&"
import style0 from "./offer.vue?vue&type=style&index=0&id=6396392b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6396392b",
  null
  
)

export default component.exports